import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
	HostListener
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import 'rxjs/add/operator/debounceTime';

import {Speaker} from '../models/speaker';
import {SpeakerService} from '../speaker.service';


import Feature from 'ol/Feature.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { OSM, Vector as VectorSource } from 'ol/source.js';
import { Fill, Style, Stroke } from 'ol/style.js';
import { fromLonLat } from 'ol/proj';


@Component({
	selector: 'map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.css'],
	encapsulation: ViewEncapsulation.None
})

export class MapComponent implements OnInit {
	
	stats: any;
	chartType:string;
	candidate:any = [];
	barTypeName:string;
	windowResizeObs: Subject<any> = new Subject<any>();
	
	osmLayer: TileLayer;
	
	windowResizeSubs = this.windowResizeObs.debounceTime(200).subscribe(_new => {
		this.update(this.stats);
	});
	
	scale: any[];
	regionMappings = {
		// 'UK': ['United Kingdom'],
		'India': ['India'],
		'Spain': ['Spain'],
		'Mexico': ['Mexico'],
		'Hong Kong': ['Hong Kong'],
		'Italy': ['Italy'],
		'China': ['China'],
		'Sri Lanka': ['Sri Lanka'],
		'Brazil': ['Brazil'],
		'Russia': ['Russia'],
		'Argentina': ['Argentina'],
		'Moldova': ['Moldova']
	};

	constructor(private speakerSrv: SpeakerService) {
		this.speakerSrv.statsChange.subscribe(stats => {
			this.stats = stats;
			this.update(stats);
		});
	}
	
	ngOnInit(): void {
		
		this.osmLayer = new TileLayer({
			source: new OSM(),
			visibility: false
		});
		
		let map1 = new Map({
			layers: [
				// basetile,
				this.osmLayer,
				new VectorLayer({
					source: new VectorSource({
						url: 'https://raw.githubusercontent.com/LoveenDyall/CASS/master/world-geojson-lite',
						format: new GeoJSON({ featureProjection: 'EPSG:3857', dataProjection: 'EPSG:4326' })
					}),
					style: (feature) => {
						for (let region of this.candidate) {
							if (region.id == feature.values_['name']) {
								return region.col;
							}
						}
						return new Style({
							stroke: new Stroke({
								color: 'rgba(0, 0, 0, 0.3)'
							})
						});
					}
				})
			],
			target: 'map1',
			view: new View({
				center: fromLonLat([0, 26]),
				zoom: 1.85,
				projection: 'EPSG:3857'
			})
		});
		
		map1.on('click', (evt) => {
			let features = map1.getFeaturesAtPixel(evt.pixel);
			if (features && features.length > 0) {
				let wantedId = features[0].values_['name'];
				for (let region of Object.keys(this.regionMappings)) {
					for (let id of this.regionMappings[region]) {
						if (id == wantedId) {
							this.speakerSrv.changeView('Concordance', event);
							this.speakerSrv.concordanceMapFilter.next({
								'role': 'Candidate',
								'country': region
							});
							return;
						}
					}
				}
			}
		});
		map1.on('moveend', (evt) => {
			let newZoom = map1.getView().getZoom();
			if (newZoom > 2.2) {
				this.osmLayer.setVisible(true)
			} else {
				this.osmLayer.setVisible(false);
			}
		});
	}
	
	update(stats) {
		let candidates = {};
		
		generateData(stats["Candidate"], candidates);
		
		let regionsCand = [];
		let min = candidates["India"];
		let max = candidates["India"];
		
		for (let region of Object.keys(this.regionMappings)) {
			let frequencyCand = candidates[region];
			
			if (frequencyCand < min)
				min = frequencyCand;
			if (frequencyCand > max)
				max = frequencyCand;
		}
		
		let colstop2 = 'rgba(210, 112, 206,';
		
		this.scale = [];
		
		let range = max - min;
		let ticks = 5;
		let tickD = range / ticks;
		
		for (let i = min; i <= max; i += tickD) {
			let ratio = (i - min) / range;
			let opc = ratio * 0.7 + 0.2;
			this.scale.push({
				v: i,
				c2: colstop2 + opc + ')'
			})
		}
		
		for (let region of Object.keys(this.regionMappings)) {
			let freq = candidates[region];
			
			let ratio1 = (freq - min) / (max - min);
			// console.log(region, ratio1, candidates[region], 'color', colstop2 + (ratio1 * 0.5 + 0.07) + ')');
			
			let style94 = new Style({
				fill: new Fill({
					color: colstop2 + (ratio1 * 0.5 + 0.07) + ')'
				}),
				stroke: new Stroke({
					color: 'rgba(0, 0, 0, 0.3)'
				})
			});
			for (let i = 0; i < this.regionMappings[region].length; i++) {
				regionsCand.push({"id": this.regionMappings[region][i], "col": style94});
			}
		}
		
		this.candidate = regionsCand;
		
		function generateData(corpusSpeakers, output) {
			let counts = {};
			if (corpusSpeakers) {
				for (let speaker of Object.keys(corpusSpeakers)) {
					if (output[corpusSpeakers[speaker]["country"]] != undefined) {
						counts[corpusSpeakers[speaker]["country"]] += 1;
						output[corpusSpeakers[speaker]["country"]] += corpusSpeakers[speaker]["relative"];
					} else {
						output[corpusSpeakers[speaker]["country"]] = corpusSpeakers[speaker]["relative"];
						counts[corpusSpeakers[speaker]["country"]] = 1;
					}
				}
				for (let area of Object.keys(output)) {
					output[area] = output[area] / counts[area];
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/map/map.component.ts